var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7579 21.4685C22.4022 23.1734 20.6078 24.4772 18.5673 25.24C16.5267 26.0029 14.317 26.196 12.175 25.7987C10.033 25.4014 8.03953 24.4287 6.40847 22.9849C4.77741 21.5411 3.57025 19.6806 2.91645 17.6031C2.26265 15.5255 2.18688 13.3092 2.69726 11.1918C3.20764 9.07449 4.28492 7.13597 5.81357 5.58418C7.34221 4.0324 9.26455 2.92589 11.3744 2.38333C17.2233 0.88365 23.2776 3.89351 25.5127 9.50232M26.3633 2.00391V9.50232H18.8629",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.d88c279a6c688754cb0edff21bf79cf3.svg";
export { ForwardRef as ReactComponent };